import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatValue',
    standalone: false
})
// @Cursor - Begin
export class FormatValuePipe implements PipeTransform {
  transform(value: any, textFormat?: string, formatAsCurrency?: boolean): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const numValue = typeof value === 'string' ? parseFloat(value) : Number(value);
    
    if (isNaN(numValue)) {
      return value?.toString() || '';
    }

    // Handle percentage formatting
    if (textFormat === 'PERCENT') {

        return (numValue * 100).toFixed(2) + '%';

    }

    // Handle currency formatting
    if (formatAsCurrency) {
      return numValue.toFixed(2);
    }

    // Default: return the value as is
    return value.toString();
  }
} 
// @Cursor - End